







































import Vue from 'vue'
import axios from 'axios'
import ExmasForTensakuVisiter from '../../utils/ExmasForTensakuVisiter'

export type DataType = {
  message: string
  status: string
}
export default Vue.extend({
  data(): DataType {
    return {
      message: '',
      status: '',
    }
  },
  created() {
    if (this.isMailAuthenticatePage) {
      this.registCheck()
    }

  },
  computed: {
    // 最初にメールアドレスや氏名を登録した直後の画面かどうか
    isPreregistResultPage(): boolean {
      return !this.$route.params.codes
    },
    // 仮登録メールに記載のURLから開いた際の画面かどうか
    isMailAuthenticatePage(): boolean {
      return !this.isPreregistResultPage
    },

    questionPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/faq/`
    }
  },
  methods: {
    async registCheck() {
      const tokens = this.$route.params.codes
      const res = await axios.get('/api/v1/preuser_regist?tokens=' + tokens)
      if (res.data.message == "ok") {
        //create new user if email doesn't exist
        try {
          const res = await axios.post('/api/v1/auth', {
            tokens: tokens,
          })
          this.status = res.data.status
          const examGroupKey = res.data.data.exam_id
          if (Object.keys(ExmasForTensakuVisiter).includes(examGroupKey)) {
            this.$store.commit('SET_EXAM_INFO', { examInfo: ExmasForTensakuVisiter[examGroupKey] })
          }
          if (res.data.status == "success") {
            this.message = "ユーザー名とパスワードがメールで送信されました。"
          }
        } catch(e) {
          this.message = "こちらのアカウントはすでに認証済みです。"
        }
      } else if (res.data.message == "failed") {
        this.message = "アカウント作成期間が過ぎていますので、再度登録してください。"
      }
    }
  }
})
